/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Other5Inputs */

const en_job_form_enum_other5 = /** @type {(inputs: Job_Form_Enum_Other5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const de_job_form_enum_other5 = /** @type {(inputs: Job_Form_Enum_Other5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonstiges`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {Job_Form_Enum_Other5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_other5 = /** @type {((inputs?: Job_Form_Enum_Other5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Other5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_other5(inputs)
	return en_job_form_enum_other5(inputs)
});
export { job_form_enum_other5 as "job_form_enum_OTHER" }